import { useState } from 'react';
import { DependencyService, DependencyInfo } from '../services/dependencyService';
import toast from 'react-hot-toast';

interface DeletionProtectionData {
  entityName: string;
  entityType: string;
  dependencies: DependencyInfo[];
}

export const useDeletionProtection = () => {
  const [showDeletionProtectionModal, setShowDeletionProtectionModal] = useState(false);
  const [deletionProtectionData, setDeletionProtectionData] = useState<DeletionProtectionData | null>(null);

  const checkAndDelete = async (
    entityType: string,
    entityId: string,
    entityName: string,
    deleteFunction: () => Promise<void>
  ) => {
    try {
      const dependencyResult = await DependencyService.checkDeletionDependencies(entityType, entityId);
      
      if (!dependencyResult.canDelete) {
        // Show deletion protection modal
        setDeletionProtectionData({
          entityName,
          entityType,
          dependencies: dependencyResult.dependencies
        });
        setShowDeletionProtectionModal(true);
        return false; // Deletion was prevented
      }

      // If no dependencies, proceed with deletion
      if (window.confirm(`Are you sure you want to delete ${entityName}?`)) {
        await deleteFunction();
        return true; // Deletion was successful
      }
      
      return false; // User cancelled
    } catch (error) {
      console.error('Error checking dependencies:', error);
      toast.error('Failed to check dependencies. Please try again.');
      return false;
    }
  };

  const closeDeletionProtectionModal = () => {
    setShowDeletionProtectionModal(false);
    setDeletionProtectionData(null);
  };

  return {
    showDeletionProtectionModal,
    deletionProtectionData,
    checkAndDelete,
    closeDeletionProtectionModal
  };
};
